import React from "react";
import Image from "../../components/image";

const FocusServiceCard = ({
  icon,
  title = "",
  description = "",
  className = "",
  imageContainerClass = "bg-yellow-lighter",
  titleClass = "",
  descriptionClass = "",
  containerClass = "group relative max-w-sm p-8 rounded-lg gvi-fservice-card bg-primary-bg h-full",
  contentClass = "",
  contentTitleClass = "w-8/12 pb-4 text-xl font-normal font-alice planet:font-light planet:lato-300-latin planet:font-body text-generic-text planet:text-white",
  imageClass = "brightness-200",
  imageOuterContainerClass = "flex items-center justify-center fservice-card-icon w-[54px] h-[57px] p-3 absolute right-3 top-0 planet:bg-gray-darkhover rounded-br-xs rounded-bl-xs"
}) => {
  return (
    <>
      <div className={`${containerClass} ${className}`}>
        {icon && (
          <div className={`${imageOuterContainerClass} ${imageContainerClass}`}>
            <Image
              imageAlt={title}
              image={""}
              imageClass={imageClass}
              sourceUrl={icon}
            />
          </div>
        )}
        <div className={`${contentClass}`}>
          {title && (
            <h2
              className={`${contentTitleClass} ${titleClass}`}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {description && (
            <div
              className={`text-base font-normal text-card-desc-text lato-300-latin ${descriptionClass}`}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default FocusServiceCard;
